exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checklist-collapse-item .el-collapse-item__header:hover{background-color:#f5faff!important;border-left:3px solid #007bff;cursor:pointer}.checklist-collapse-item.is-active .el-collapse-item__header{background-color:#e6f0ff!important;border-left:3px solid #007bff}.el-collapse-item__header{transition:background-color .3s ease,border-left .3s ease}.checklist-item{background:#f9f9f9;border-radius:6px}.checklist-item label{font-weight:500;text-align:left}.checklist-item .form-group{margin-bottom:.75rem}", ""]);

// exports
